// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SJT5","right":"styles_right__2Sw25"};